// src/features/dashboard/utils/activityDetails.utils.ts

/**
 * Get Total Apps Text
 */
export const getAppsCountText = (
  total: number,
) => {

  return `${total} apps`;
};